import React from "react";
import { getLanguageValue } from "locales/i18n";
import { PAGE_TYPE } from "enums";
import { getAgencyLogoImageUrl } from "helpers/Image.helper";

// 스켈레톤 컴포넌트
const SkeletonStatsCard = () => (
    <div className="bg-gray-50 p-3 sm:p-4 rounded-lg sm:rounded-xl animate-pulse">
        <div className="flex flex-row sm:flex-col h-full justify-between sm:justify-start">
            <div className="bg-gray-200 rounded h-3 sm:h-4 w-20 sm:w-24 mb-0 sm:mb-2 mr-2 sm:mr-0"></div>
            <div className="bg-gray-200 rounded h-6 sm:h-8 w-12 sm:w-16"></div>
        </div>
    </div>
);

const SkeletonSection = () => (
    <section className="bg-white rounded-2xl shadow-sm overflow-hidden mb-4 sm:mb-6 animate-pulse">
        <div className="p-3 sm:p-4 md:p-6">
            <div className="space-y-4 sm:space-y-6">
                <div>
                    <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
                        <SkeletonStatsCard />
                        <SkeletonStatsCard />
                        <SkeletonStatsCard />
                        <SkeletonStatsCard />
                        <SkeletonStatsCard />
                    </div>
                </div>
            </div>
        </div>
    </section>
);

const IndexComponent = (props: any) => {
    const { viewCount, favoriteCount, todayViewCount, agencyViewCount, fanpageViewCount, castingManagerViewCount, errorMessage, isLoading, showAgencyInfoPopup } = props;

    return (
        <main className="bg-gray-50 min-h-screen">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
                {/* 헤더 제목은 항상 표시 */}
                <h2 className="text-2xl font-extrabold text-gray-800 mb-10">
                    {getLanguageValue(PAGE_TYPE.STUDENT, "profileSummary.txtTitle")}
                </h2>

                {isLoading ? (
                    /* 프로필 통계 섹션 스켈레톤 */
                    <SkeletonSection />
                ) : errorMessage ? (
                    <div className="flex justify-center items-center h-64 bg-red-200 border border-red-500 text-red-800 px-5 py-4 rounded-lg" role="alert">
                        <strong className="font-bold">Error: </strong>
                        <span className="ml-2">{errorMessage}</span>
                    </div>
                ) : (

                    <div className="space-y-10">
                        {/* 내 프로필 정보 */}
                        <section className="bg-white rounded-2xl shadow-sm overflow-hidden mb-4 sm:mb-6">
                            <div className="p-3 sm:p-4 md:p-6">
                                <div className="space-y-4 sm:space-y-6">
                                    {/* 프로필 통계 섹션 */}
                                    <div>
                                        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
                                            {/* 총 내 프로필 즐겨찾기 수 */}
                                            <div className="bg-gray-50 p-3 sm:p-4 rounded-lg sm:rounded-xl 
                                                hover:bg-gray-100 transition-all duration-200 
                                                transform hover:-translate-y-1 shadow-sm hover:shadow">
                                                <div className="flex flex-row sm:flex-col h-full justify-between sm:justify-start">
                                                    <h3 className="text-xs sm:text-sm font-medium text-gray-500 
                                                        mb-0 sm:mb-2 mr-2 sm:mr-0">
                                                        {getLanguageValue(PAGE_TYPE.STUDENT, "profileSummary.txtFavoriteCount")}
                                                    </h3>
                                                    <p className="text-lg sm:text-xl lg:text-2xl font-bold text-[#CF3688]">
                                                        {viewCount?.toLocaleString() || "N/A"}
                                                    </p>
                                                </div>
                                            </div>

                                            {/* 총 내 프로필 즐겨찾기 수 */}
                                            <div className="bg-gray-50 p-3 sm:p-4 rounded-lg sm:rounded-xl 
                                                hover:bg-gray-100 transition-all duration-200 
                                                transform hover:-translate-y-1 shadow-sm hover:shadow">
                                                <div className="flex flex-row sm:flex-col h-full justify-between sm:justify-start">
                                                    <h3 className="text-xs sm:text-sm font-medium text-gray-500 
                                                        mb-0 sm:mb-2 mr-2 sm:mr-0">
                                                        {getLanguageValue(PAGE_TYPE.STUDENT, "profileSummary.txtTotalViewCount")}
                                                    </h3>
                                                    <p className="text-lg sm:text-xl lg:text-2xl font-bold text-[#CF3688]">
                                                        {favoriteCount?.toLocaleString() || "N/A"}
                                                    </p>
                                                </div>
                                            </div>

                                            {/* 오늘 뷰 카운트 */}
                                            <div className="bg-gray-50 p-3 sm:p-4 rounded-lg sm:rounded-xl 
                                                hover:bg-gray-100 transition-all duration-200 
                                                transform hover:-translate-y-1 shadow-sm hover:shadow">
                                                <div className="flex flex-row sm:flex-col h-full justify-between sm:justify-start">
                                                    <h3 className="text-xs sm:text-sm font-medium text-gray-500 
                                                        mb-0 sm:mb-2 mr-2 sm:mr-0">
                                                        {getLanguageValue(PAGE_TYPE.STUDENT, "profileSummary.txtTodayViewCount")}
                                                    </h3>
                                                    <p className="text-lg sm:text-xl lg:text-2xl font-bold text-[#CF3688]">
                                                        {todayViewCount?.toLocaleString() || "N/A"}
                                                    </p>
                                                </div>
                                            </div>

                                            {/* 기획사 뷰 카운트 */}
                                            <div className="bg-gray-50 p-3 sm:p-4 rounded-lg sm:rounded-xl 
                                                hover:bg-gray-100 transition-all duration-200 
                                                transform hover:-translate-y-1 shadow-sm hover:shadow">
                                                <div className="flex flex-row sm:flex-col h-full justify-between sm:justify-start">
                                                    <h3 className="text-xs sm:text-sm font-medium text-gray-500 
                                                        mb-0 sm:mb-2 mr-2 sm:mr-0">
                                                        {getLanguageValue(PAGE_TYPE.STUDENT, "profileSummary.txtWeeklyViewCount")}
                                                    </h3>
                                                    <p className="text-lg sm:text-xl lg:text-2xl font-bold text-[#CF3688]">
                                                        {agencyViewCount?.toLocaleString() || "N/A"}
                                                    </p>
                                                </div>
                                            </div>

                                            {/* 팬페이지 뷰 카운트 */}
                                            <div className="bg-gray-50 p-3 sm:p-4 rounded-lg sm:rounded-xl 
                                                hover:bg-gray-100 transition-all duration-200 
                                                transform hover:-translate-y-1 shadow-sm hover:shadow">
                                                <div className="flex flex-row sm:flex-col h-full justify-between sm:justify-start">
                                                    <h3 className="text-xs sm:text-sm font-medium text-gray-500 
                                                        mb-0 sm:mb-2 mr-2 sm:mr-0">
                                                        {getLanguageValue(PAGE_TYPE.STUDENT, "profileSummary.txtMonthlyViewCount")}
                                                    </h3>
                                                    <p className="text-lg sm:text-xl lg:text-2xl font-bold text-[#CF3688]">
                                                        {fanpageViewCount?.toLocaleString() || "N/A"}
                                                    </p>
                                                </div>
                                            </div>

                                            {/* 캐스팅 매니저 뷰 카운트 */}
                                            <div className="bg-gray-50 p-3 sm:p-4 rounded-lg sm:rounded-xl 
                                                hover:bg-gray-100 transition-all duration-200 
                                                transform hover:-translate-y-1 shadow-sm hover:shadow">
                                                <div className="flex flex-row sm:flex-col h-full justify-between sm:justify-start">
                                                    <h3 className="text-xs sm:text-sm font-medium text-gray-500 
                                                        mb-0 sm:mb-2 mr-2 sm:mr-0">
                                                        {getLanguageValue(PAGE_TYPE.STUDENT, "profileSummary.txtCastingManagerViewCount")}
                                                    </h3>
                                                    <p className="text-lg sm:text-xl lg:text-2xl font-bold text-[#CF3688]">
                                                        {castingManagerViewCount?.toLocaleString() || "N/A"}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* 나를 즐겨찾기한 기획사 목록 */}
                        {/* <section>
                                <h3 className="text-xl font-bold text-gray-800 mb-6">
                                    {getLanguageValue(PAGE_TYPE.STUDENT, "profileSummary.txtFavoriteListByAgency")}
                                </h3>
                                {info.favoriteList.length === 0 ? (
                                    <div className="text-gray-500 text-sm">
                                        {getLanguageValue(PAGE_TYPE.STUDENT, "profileSummary.txtNoFavoriteList")}
                                    </div>
                                ) : (
                                    <div className="overflow-x-auto">
                                        <div className="flex gap-4 pb-4 min-w-max">
                                            {info.favoriteList.map((favorite: any) => (
                                                <div
                                                    key={favorite.userAgencyInfo.agencyInfo.id}
                                                    onClick={() => showAgencyInfoPopup(favorite.userAgencyInfo.agencyInfo.id)}
                                                    className="flex-shrink-0 cursor-pointer group hover:scale-105 transition-transform duration-200">
                                                    <div className="rounded-full overflow-hidden w-16 h-16 sm:w-20 sm:h-20 flex-shrink-0 border-2 border-gray-100 group-hover:border-[#CF3688] transition-colors duration-200 shadow-sm group-hover:shadow-md bg-gray-50">
                                                        <img
                                                            src={getAgencyLogoImageUrl(favorite.userAgencyInfo.agencyInfo.logoImageInfo)}
                                                            alt={favorite.userAgencyInfo.agencyInfo.nameEn}
                                                            className="w-full h-full object-contain p-1"
                                                        />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </section> */}

                    </div>
                )}
            </div>
        </main>
    );
};

export default IndexComponent;